module.exports = __webpack_public_path__ + "img/team5.1e96c32e.png";